<template>
  <div>
    <canvas id="connections-effect-canvas" class="d-none d-xl-block" style="z-index: -1;"></canvas>
    <div class="d-none d-lg-flex container-fluid px-5">
        <div class="pandora-title w-100">
            <main-header />
        </div>
    </div>
    <div class="d-lg-none d-md-flex container-fluid width-100">
        <div class="pandora-title w-100">
            <main-header />
        </div>
    </div>
    <div class="d-none d-lg-flex pb-5 px-5">
      <div class="container-fluid pt-5">
        <div class="row d-none d-lg-flex">
            <div class="col-md-5">
                <div class="row h-100">
                    <div class="col-md-12 pr-none"> 
                        <router-link to="list/live">
                            <main-tile image="icona_live_tv.png" title="<h1 class='text-center title'><strong>LIVE TV</strong></h1>" dimension-card="testimonial-card h-100"  div-id="div-livetv" />                     
                        </router-link>
                    </div>
                </div>  
            </div>
            <div class="col-md-7">
                <div class="row form-group">
                    <div class="col-md-4 pr-none">
                        <router-link to ="/prossimi-tg">
                            <main-tile image="icona_prossimi_tg.png" title="<h5 class='text-center title'><strong>I PROSSIMI <br>TG</strong></h5>" dimension-card="testimonial-card-sm" div-id="div-tg"/>                     
                        </router-link>
                        
                    </div>
                    
                    <div class="col-md-8 pr-none">
                        <a href="https://convergenze.it/" target="_blank">
                            <div class="d-none d-md-block card-image testimonial-card-sm pt-4">
                                <span class='text-center title-banner text-white pt-5'>Entra in Convergenze!</span>
                                <br><span class='text-center subtitle-banner text-white pt-2'>
                                    Il network più interconnesso!<br>
                                    d'Italia e il 10&deg; al mondo.
                                </span>
                            </div>
                        </a> 
                    </div>
                      
                </div>
                
                <div class="row">

                    <div class="col-md-4 pr-none">
                        <a href="https://convergenze.it/it/servizi/servizi-unici/mylife" target="_blank">
                            <main-tile image="icona_mylife.png" title="<h5 class='text-center title'><strong>LE MIE REGISTRAZIONI <br>MYLIFE</strong></h5>" dimension-card="testimonial-card-sm" div-id="div-mylife" />                     
                        </a>
                    </div>
                    <!-- <div class="col-md-4">
                        <router-link to="/presto-online">
                            <main-tile image="icona_video_makers.png" title="<h5 class='text-center title'>VIDEO <br>MAKERS</h5>" dimension-card="testimonial-card-sm" div-id="div-video" />                     
                        </router-link>
                    </div> -->
                     <div class="col-md-4 pr-none">
                        <router-link to="/search-territorio">
                            <main-tile image="icona_territorio.png" title="<h5 class='text-center title'><strong>CERCA NEL<br>TERRITORIO</strong></h5>" dimension-card="testimonial-card-sm" div-id="div-territorio" />                     
                        </router-link> 
                    </div> 
                    <div class="col-md-4 pr-none">
                        <a href="https://convergenze.it/it/area-clienti/login" target="_blank">
                            <main-tile image="icona_home_pandora.png" title="<h5 class='text-center title'><strong>HOME <br>PANDORA</strong></h5>" dimension-card="testimonial-card-sm" div-id="div-homepandora"/>                     
                        </a>
                    </div>
                </div>  
            </div>
        </div>
      </div>  
    </div>
    <!-- MODALITA RESPONSIVE -->
    <div class="d-flec d-lg-none pb-1">
        <div class="container-fluid pt-5">
            <div class="row d-lg-none d-flex">
                <div class="col-md-5 form-group">
                    <div class="row h-100">
                        <div class="col-md-12"> 
                            <router-link to="list/live">
                                <main-tile image="icona_live_tv.png" title="<h1 class='text-center title'><strong>LIVE TV</strong></h1>" dimension-card="testimonial-card h-100"  div-id="div-livetv" />                     
                            </router-link>
                        </div>
                    </div>  
                </div>
                <div class="col-md-7">
                    <div class="row form-group">
                        <div class="col-md-4 form-group">
                            <router-link to ="/prossimi-tg">
                                <main-tile image="icona_prossimi_tg.png" title="<h5 class='text-center title'><strong>I PROSSIMI <br>TG</strong></h5>" dimension-card="testimonial-card-sm" div-id="div-tg"/>                     
                            </router-link>
                        </div>
                        
                        <div class="col-md-8">
                            <div class="d-block height-sm">
                                <a href="https://convergenze.it/" target="_blank">
                                    <div class="d-sm-block card-image-sm testimonial-card-sm pt-4">
                                        <span class='text-center title-banner text-white pt-5'>Entra in Convergenze!</span>
                                        <br><span class='text-center subtitle-banner text-white pt-2'>
                                            Il network più interconnesso!<br>
                                            d'Italia e il 10&deg; al mondo.
                                        </span>
                                    </div>
                                </a>                                 
                            </div>
                        </div>
                        
                    </div>
                    
                    <div class="row">

                        <div class="col-md-4 form-group">
                            <a href="https://convergenze.it/it/servizi/servizi-unici/mylife" target="_blank">
                                <main-tile image="icona_mylife.png" title="<h5 class='text-center title'><strong>LE MIE REGISTRAZIONI <br>MYLIFE</strong></h5>" dimension-card="testimonial-card-sm" div-id="div-mylife" />                     
                            </a>
                        </div>
                        <!--<div class="col-md-4 form-group">
                            <router-link to="/presto-online">
                                <main-tile image="icona_video_makers.png" title="<h5 class='text-center title'>VIDEO <br>MAKERS</h5>" dimension-card="testimonial-card-sm" div-id="div-video" />                     
                            </router-link>
                        </div>-->
                        <div class="col-md-4 form-group">
                            <router-link to="/search-territorio">
                                <main-tile image="icona_territorio.png" title="<h5 class='text-center title'><strong>CERCA NEL<br>TERRITORIO</strong></h5>" dimension-card="testimonial-card-sm" div-id="div-territorio" />                     
                            </router-link>
                        </div> 
                        <div class="col-md-4 form-group">
                            <a href="https://convergenze.it/it/area-clienti/login" target="_blank">
                                <main-tile image="icona_home_pandora.png" title="<h5 class='text-center title'><strong>HOME <br>PANDORA</strong></h5>" dimension-card="testimonial-card-sm" div-id="div-homepandora"/>                     
                            </a>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>
    <br>
    <footer class="navbar footer navbar-trasparent text-center px-5">
        <main-footer />
    </footer>
  </div>  
</template>

<script>
// @ is an alias to /src
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import MainTile from '@/components/MainTile.vue'
//import SideMenu from '@/components/SideMenu.vue'


export default {
  name: 'index',
  components: {
    MainHeader,MainFooter,MainTile
  },
  computed: {       
  },
  methods: {    
  },
  created: () => {      
  }
}
</script>

<style scoped lang="scss">


</style>